module.exports = __webpack_public_path__ + "static/img/supplier2.16db985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplier2.png
// module id = 57X6
// module chunks = 192